<template>
    <div class="heading__box">
        <h2>{{ heading }}</h2>
        <div v-if="hasLink" :key="'link to all products'">
            <router-link
                :to="{ path: link }"
                :class="{ translate__bottom: isTranslate }"
                v-if="!isHasButton"
                :key="'router link'"
            >
                <span>
                    все
                </span>

                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5 13.0002H16.17L11.29 17.8802C10.9 18.2702 10.9 18.9102 11.29 19.3002C11.68 19.6902 12.31 19.6902 12.7 19.3002L19.29 12.7102C19.68 12.3202 19.68 11.6902 19.29 11.3002L12.71 4.70021C12.32 4.31021 11.69 4.31021 11.3 4.70021C10.91 5.09021 10.91 5.72022 11.3 6.11022L16.17 11.0002H5C4.45 11.0002 4 11.4502 4 12.0002C4 12.5502 4.45 13.0002 5 13.0002Z"
                        fill="#313D65"
                    />
                </svg>
            </router-link>

            <button
                :class="{ translate__bottom: isTranslate }"
                @click="btnClicked"
                v-else
            >
                <span>
                    все
                </span>

                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5 13.0002H16.17L11.29 17.8802C10.9 18.2702 10.9 18.9102 11.29 19.3002C11.68 19.6902 12.31 19.6902 12.7 19.3002L19.29 12.7102C19.68 12.3202 19.68 11.6902 19.29 11.3002L12.71 4.70021C12.32 4.31021 11.69 4.31021 11.3 4.70021C10.91 5.09021 10.91 5.72022 11.3 6.11022L16.17 11.0002H5C4.45 11.0002 4 11.4502 4 12.0002C4 12.5502 4.45 13.0002 5 13.0002Z"
                        fill="#313D65"
                    />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        heading: {
            required: true,
            type: String
        },

        linkShow: {
            required: false,
            type: String
        },

        link: {
            required: false,
            type: String
        },

        isTranslate: {
            required: false,
            type: Boolean
        },

        isHasButton: {
            required: false,
            type: Boolean
        }
    },

    data() {
        return {
            hasLink: true
        };
    },

    methods: {
        btnClicked() {
            this.$emit("btn-clicked");
        }
    },

    mounted() {
        this.linkShow === "false" ? (this.hasLink = false) : this.hasLink;
    }
};
</script>

<style lang="scss" scoped>
.heading__box {
    display: flex;
    justify-content: center;
    margin: 50px 0 35px;

    position: relative;

    h2 {
        font-family: Acrom-Bold, sans-serif;
        font-size: 28px;
        line-height: 1;
        /* identical to box height */
        /* black_main */
        color: #363f4d;

        margin-bottom: 0;
    }

    a,
    button {
        position: absolute;
        right: 0;
        display: flex;
        align-items: center;
        background-color: transparent;
        padding: 0;
        outline: none;
        border: none;

        span {
            font-family: Acrom-Bold, sans-serif;
            font-size: 20px;
            line-height: 1;
            color: #363f4d;
            margin-bottom: 2px;
        }

        svg {
            width: 20px;
            height: 20px;
        }

        &:hover {
            cursor: pointer;
            text-decoration: underline;
        }
    }
}
@media only screen and (max-width: 768px) {
    .heading__box {
        margin: 40px 0 28px;

        h2 {
            font-size: 24px;
        }

        a,
        button {
            span {
                font-size: 17px;
            }
        }
    }
}

@media only screen and (max-width: 550px) {
    .heading__box {
        margin: 40px 0 20px;

        h2 {
            font-size: 20px;
        }
    }
}

@media only screen and (max-width: 440px) {
    .heading__box {
        .translate__bottom {
            top: 20px;
        }
    }
}
</style>
